// angular imports
import { 
    WritableSignal, 
    signal 
} from "@angular/core";

//local imports

import {
  RoomModel,
  ProgramModel,
  ProjectModel,
  CategoryModel,
  DepartmentGroupModel,
  DepartmentModel,
  RoomContentModel,
  RoomGroupModel,
} from "@app/catalog";

export class CatalogManagementModel
{
  public rooms: WritableSignal<RoomModel[]>;
  public departments: WritableSignal<DepartmentModel[]>;
  public projects: WritableSignal<ProjectModel[]>;
  public programs: WritableSignal<ProgramModel[]>;
  public categories: WritableSignal<CategoryModel[]>;
  public roomContents: WritableSignal<RoomContentModel[]>;
  public roomGroups: WritableSignal<RoomGroupModel[]>;
  public departmentGroups: WritableSignal<DepartmentGroupModel[]>;
  public companyId: string;

  constructor()
  {
    this.rooms = signal<RoomModel[]>([]);
    this.departments = signal<DepartmentModel[]>([]);
    this.projects = signal<ProjectModel[]>([]);
    this.programs = signal<ProgramModel[]>([]);
    this.categories = signal<CategoryModel[]>([]);
    this.roomContents = signal<RoomContentModel[]>([]);
    this.roomGroups = signal<RoomGroupModel[]>([]);
    this.departmentGroups = signal<DepartmentGroupModel[]>([]);

    this.companyId = "";

  }
}
